export default class AppConfig {
    public static Name = 'Amplify Platform';
    public static Version = 'v0.1';
}
